var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import { Card, CardBody, CardFooter, Container } from 'reactstrap';
import Col from 'reactstrap/es/Col';
import Row from 'reactstrap/es/Row';
import { ApplicationContext } from '../../../ApplicationContext';
import GetServiceSchemasCommand from '../../../commands/services/GetServiceSchemasCommand';
import { Roles } from "../../../data/Roles";
import ServiceEntryStatus from '../../../data/ServiceEntryStatus';
import Signals from '../../../signals/Signals';
import AssetMetaData from '../../components/ui/AssetMetaData/AssetMetaData';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import DateTime from '../../components/ui/DateTime/DateTime';
import Role from "../../components/ui/Role/Role";
import CloseServiceEntryOverlay from './CloseServiceEntryOverlay';
import ServiceEntryStatusComponent from './ServiceEntryStatusComponent';
import SetServiceEntryInProgressOverlay from './SetServiceEntryInProgressOverlay';
import UpdateServiceEntryOverlay from './UpdateServiceEntryOverlay';
import { UserName } from "./UserName";
/**
 *
 */
var ViewServiceEntryOverlay = /** @class */ (function (_super) {
    __extends(ViewServiceEntryOverlay, _super);
    /**
     *
     * @param props
     */
    function ViewServiceEntryOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onUpdateServiceEntry = _this.onUpdateServiceEntry.bind(_this);
        _this.onCloseServiceEntry = _this.onCloseServiceEntry.bind(_this);
        _this.onServiceEntryInProgress = _this.onServiceEntryInProgress.bind(_this);
        return _this;
    }
    /**
     *
     */
    ViewServiceEntryOverlay.prototype.componentDidMount = function () {
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection, assetCollection = _a.assetCollection;
        var user = session.user;
        new GetServiceSchemasCommand().execute(user, serviceSchemaCollection);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ViewServiceEntryOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    };
    /**
     *
     */
    ViewServiceEntryOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl, serviceEntryModel = _a.serviceEntryModel;
        return React.createElement(Container, { className: 'view-service-entry-overlay w-100 ' + className },
            React.createElement(Card, { className: "bg-white" },
                React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'service.entry.view.overlay.title' }, serviceEntryModel) }),
                React.createElement(CardBody, null,
                    React.createElement(Row, { className: "text-muted mb-3" },
                        React.createElement(Col, null,
                            React.createElement(AssetMetaData, { serviceEntryModel: serviceEntryModel }))),
                    React.createElement(Row, { className: "mb-3" },
                        React.createElement(Col, { sm: 12 },
                            React.createElement(ServiceEntryStatusComponent, { serviceEntryModel: serviceEntryModel }))),
                    serviceEntryModel.description &&
                        React.createElement(Row, { className: "mb-3" },
                            React.createElement(Col, null,
                                React.createElement("label", { className: "font-weight-bold w-100" },
                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.description" })),
                                serviceEntryModel.description)),
                    serviceEntryModel.resolution &&
                        React.createElement(Row, { className: "mb-3" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement("label", { className: "font-weight-bold w-100" },
                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.resolution" })),
                                serviceEntryModel.resolution)),
                    React.createElement("hr", { className: "w-100" }),
                    React.createElement(Row, null,
                        React.createElement(Col, { className: "d-flex px-0", sm: 12 },
                            React.createElement(Col, { sm: 12, md: 2 },
                                React.createElement("label", { className: "font-weight-bold w-100" },
                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.created" }))),
                            React.createElement(Col, { sm: 12, md: 10 },
                                React.createElement(UserName, { userId: serviceEntryModel.createdByUserId }),
                                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.creationDateTimeUtc, hideTime: true }),
                                serviceEntryModel.assetValueOnCreation > 0 &&
                                    React.createElement("div", { className: "text-muted" },
                                        React.createElement(FormattedMessage, { id: "page.service.entries.table.column.valueoncreate" }),
                                        ":\u00A0",
                                        React.createElement(FormattedNumber, { value: serviceEntryModel.assetValueOnCreation, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })))),
                        serviceEntryModel.lastModifiedDateTimeUtc
                            && serviceEntryModel.lastModifiedDateTimeUtc.getTime() - serviceEntryModel.creationDateTimeUtc.getTime() > 0
                            && React.createElement(Col, { className: "d-flex mt-3 px-0", sm: 12 },
                                React.createElement(Col, { sm: 12, md: 2 },
                                    React.createElement("label", { className: "font-weight-bold w-100" },
                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.modified" }))),
                                React.createElement(Col, { sm: 12, md: 10 },
                                    React.createElement(UserName, { userId: serviceEntryModel.lastModifiedByUserId }),
                                    React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.lastModifiedDateTimeUtc, hideTime: true }))),
                        serviceEntryModel.scheduledDateTimeUtc &&
                            React.createElement(Col, { className: "d-flex mt-3 px-0", sm: 12 },
                                React.createElement(Col, { sm: 12, md: 2 },
                                    React.createElement("label", { className: "font-weight-bold w-100" },
                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.scheduleddate" }))),
                                React.createElement(Col, { sm: 12, md: 10 },
                                    React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.scheduledDateTimeUtc, hideTime: true }))),
                        serviceEntryModel.dueDateTimeUtc &&
                            React.createElement(Col, { className: "d-flex mt-3 px-0", sm: 12 },
                                React.createElement(Col, { sm: 12, md: 2 },
                                    React.createElement("label", { className: "font-weight-bold w-100" },
                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.duedate" }))),
                                React.createElement(Col, { sm: 12, md: 10 },
                                    React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.dueDateTimeUtc, hideTime: true }))),
                        serviceEntryModel.closeDateTimeUtc &&
                            React.createElement(Col, { className: "d-flex mt-3 px-0", sm: 12 },
                                React.createElement(Col, { sm: 12, md: 2 },
                                    React.createElement("label", { className: "font-weight-bold w-100" },
                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.closed" }))),
                                React.createElement(Col, { sm: 12, md: 10 },
                                    React.createElement(UserName, { userId: serviceEntryModel.closedByUserId }),
                                    React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.closeDateTimeUtc, hideTime: true }),
                                    serviceEntryModel.assetValueOnClose > 0 &&
                                        React.createElement("div", { className: "text-muted" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.valueonclose" }),
                                            ":",
                                            React.createElement(FormattedNumber, { value: serviceEntryModel.assetValueOnClose, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })))))),
                serviceEntryModel.status !== ServiceEntryStatus.Closed ?
                    //    Open options
                    React.createElement(CardFooter, null,
                        React.createElement("div", { className: "d-flex justify-content-end" },
                            serviceEntryModel.canSetInProgress &&
                                React.createElement("button", { className: "btn btn-outline-warning mr-3", onClick: this.onServiceEntryInProgress, "data-id": serviceEntryModel.serviceEntryId },
                                    React.createElement("i", { className: "fe fe-edit-2" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "page.service.entries.progress" })),
                            serviceEntryModel.canUpdate &&
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", onClick: this.onUpdateServiceEntry, "data-id": serviceEntryModel.serviceEntryId },
                                    React.createElement("i", { className: "fe fe-edit-2" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "page.service.entries.edit" })),
                            React.createElement(Role, { roles: [Roles.OWNER] }, serviceEntryModel.dueDateTimeUtc &&
                                React.createElement("button", { className: "btn btn-outline-success", onClick: this.onCloseServiceEntry, "data-id": serviceEntryModel.serviceEntryId },
                                    React.createElement("i", { className: "fe fe-check" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "page.service.entries.close" }))))) :
                    //    Closed options
                    React.createElement(CardFooter, null,
                        React.createElement("div", { className: "d-flex justify-content-end" }, serviceEntryModel.dueDateTimeUtc &&
                            React.createElement("button", { className: "btn btn-outline-primary mr-3", onClick: this.onUpdateServiceEntry, "data-id": serviceEntryModel.serviceEntryId },
                                React.createElement("i", { className: "fe fe-edit-2" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "page.service.entries.edit" }))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     */
    ViewServiceEntryOverlay.prototype.onUpdateServiceEntry = function () {
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.HideOverlay.dispatch();
        Signals.ShowOverlay.dispatch(React.createElement(UpdateServiceEntryOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     */
    ViewServiceEntryOverlay.prototype.onCloseServiceEntry = function () {
        Signals.HideOverlay.dispatch();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(CloseServiceEntryOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     * @param event
     */
    ViewServiceEntryOverlay.prototype.onServiceEntryInProgress = function (event) {
        Signals.HideOverlay.dispatch();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(SetServiceEntryInProgressOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    ViewServiceEntryOverlay.defaultProps = {
        className: ''
    };
    ViewServiceEntryOverlay = __decorate([
        observer
    ], ViewServiceEntryOverlay);
    return ViewServiceEntryOverlay;
}(React.Component));
ViewServiceEntryOverlay.contextType = ApplicationContext;
export default injectIntl(ViewServiceEntryOverlay);
